import type { AuthChangeEvent, Session } from '@supabase/supabase-js'

export interface SessionCookieValues {
  access: string | null
  refresh: string | null
}

/**
 * Qué debe quedar en el espejo de cookies de auth para un evento dado.
 *
 * La app manda `sb-access-token` como Bearer, pero esa cookie NO es la del SDK:
 * @nuxtjs/supabase guarda la sesión real en `sb-<ref>-auth-token` y la refresca
 * solo. La nuestra es un espejo manual, y hasta ahora sólo se escribía al entrar
 * y después de un 401 — así que caducaba cada hora.
 *
 * Devuelve `null` cuando el evento no debe tocar las cookies.
 */
export function nextSessionCookies(
  event: AuthChangeEvent,
  session: Session | null,
): SessionCookieValues | null {
  if (event === 'SIGNED_OUT') return { access: null, refresh: null }
  if (event === 'TOKEN_REFRESHED' && session) {
    return { access: session.access_token, refresh: session.refresh_token }
  }
  return null
}
